define(function (require) {
	const tpl = require('./templates/t_itv_currency_field.hbs');
	const detailUtils = require('civicsUtils/detail_utilities');
	const baseElement = require('./v_itv_base_element');
	return baseElement.extend({
		template:tpl,
		templateHelpers:function(){
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);

			var ret = {
				classes: 'text-field-container' + 
						(this.model.get('isVisible') === false ? ' hidden' : '') +
						(this.model.get('fullWidth') === true ? ' full-width' : ''),
				customAttr: () => {
					var ret = this.model.get('customAttr');
					ret+='data-dataType="' + this.model.get('dataType') + '" ';
					if (this.model.get('rangeMinValid')) {
						ret += 'data-minVal="' + this.model.get('rangeMinValid') + '" ';
					}
					if (this.model.get('rangeMaxValid')) {
						ret += 'data-maxVal="' + this.model.get('rangeMaxValid') + '" ';
					}
					if (this.config.isInGrid) {
						ret += 'specialType="grid" ';
					}
					if ( baseTH.tooltip )
					{
						ret+=' data-tooltip="' + baseTH.tooltip + '"';
					}
					return ret;
				},
				value: () => {
					var val = this.model.get('value');
					var number = detailUtils.numberFields(this.model, this.config);

					if(number.isZeroValue.condition){
							return number.isZeroValue.value;
					} else if (this.config.readOnlyForm) {
							//returned teh formatted value if read only
							return Handlebars.helpers['global:formatMoney'](val)
					}

					//otherwise return a "0" or the actual number
					if (val === 0) {
						val = val.toString();
					}
					return val;

				}
			};

			ret = $.extend({},baseTH,ret);
			return ret;
		},
		getValue: function () {
			if (this.model.get('displayOnly') === true) {
				return;
			}
			if (this.model.get('isEnabled') === false || this.config.readOnlyForm) {
				//if we're disabled the value will be on the model.
				return this.model.get('value');
			}
			var val = this.$el.find('input').val();
			if (val != null && (val == "" || val.trim().length == 0)) {
				val = 0;
			}
			return val;
		}
	});
});
